import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
const filterDataSlice = createSlice({
  name: "filterData",
  initialState: {},
  reducers: {
    setFilterData(state, action) {
      const { listId, data } = action.payload;
      state[listId] = { ...state[listId], ...data };
    },
    resetFilterData(state, action) {
      const { listId } = action.payload;
      delete state[listId];
    },
    clearAllFilterData() {
      return initialState;
    },
  },
});

export const { setFilterData, resetFilterData, clearAllFilterData } =
  filterDataSlice.actions;
export default filterDataSlice.reducer;
